import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/filters/store-cost/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const storeCost = {
  get: apiPathFunc(pathBase),
} as const;
